<script setup lang="ts">
import type { Room } from '~/shared/types/payload-types'

type FloorValue = 'souterrain' | 'ground' | 'first' | 'second' | 'third' | 'fourth' | 'garden'
type FloorGroup = { floor: FloorValue; rooms: Room[] }

defineProps<{
  floorGroups: FloorGroup[],
}>()
</script>

<template>
  <div class="flex flex-col gap-3">
    <div
      v-for="group in floorGroups"
      :key="group.floor"
      :id="group.floor"
    >
      <floorplan-floor
        :floor="group.floor"
        :rooms="group.rooms"
      />
    </div>
  </div>
</template>
